var map = {
	"./au.svg": 413,
	"./ca.svg": 414,
	"./de.svg": 415,
	"./fr.svg": 416,
	"./gb.svg": 417,
	"./hk.svg": 418,
	"./id.svg": 419,
	"./jp.svg": 420,
	"./kr.svg": 421,
	"./my.svg": 422,
	"./nz.svg": 423,
	"./ph.svg": 424,
	"./ru.svg": 425,
	"./sa.svg": 426,
	"./sg.svg": 427,
	"./th.svg": 428,
	"./tw.svg": 429,
	"./us.svg": 430,
	"./vn.svg": 431
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 412;